import Vue from 'vue'
import Router from 'vue-router'

import banners from './routes/banners'
import contents from './routes/contents'
import courses from './routes/courses'
import main from './routes/main'
import sections from './routes/sections'
import menus from './routes/menus'
import users from './routes/users'
import clients from './routes/clients'

import store from '../store/store'

Vue.use(Router)

const router = new Router({
  routes: [
    ...main,
    ...banners,
    ...sections,
    ...contents,
    ...courses,
    ...menus,
    ...users,
    ...clients
  ]
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['authentication/isAuthenticated']

  const requiresAuth = to.matched.some(({ meta }) => {
    return meta.requiresAuth
  })

  if (to.path === '/logout') {
    store.dispatch('authentication/logout')
    return next({ name: 'login' })
  }

  if (requiresAuth) {
    if (isAuthenticated) {
      if (to.path !== from.path) store.dispatch('authentication/refreshCurrentUser')
      return next()
    }

    const { name, fullPath } = to
    const query = name !== undefined ? { redirect: name } : { path: fullPath }

    return next({ name: 'login', query })
  }

  return next()
})

export { router }
